import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { string, func, bool, shape, node } from 'prop-types';
import { GenericImageIcon } from '@magalu/stereo-ui-icons';
import { Sidebar } from '..';
import ContentBox from './content-box';
import SellerDetail from './seller-detail';
import magaluCompanies from './magalu-companies';
import { DEFAULT_SELLER } from '../../constants';
import { Dialog } from '../../atoms';
import SidebarHeader from '../Sidebar/SidebarHeader';
import { Link, LogoMagaluIcon, PartnerLink } from './seller-delivery.styles';

const SellerDelivery = _ref => {
  let {
    showSellerDetailContent,
    onCloseModalContent,
    seller,
    product,
    onSellerClick,
    onOffersClick,
    disableSellerClick,
    disableSellerDetails,
    logoIconColor,
    showDialog,
    modal,
    internationalPartner,
    partnerColor,
    partnerLogo
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["showSellerDetailContent", "onCloseModalContent", "seller", "product", "onSellerClick", "onOffersClick", "disableSellerClick", "disableSellerDetails", "logoIconColor", "showDialog", "modal", "internationalPartner", "partnerColor", "partnerLogo"]);

  const {
    id,
    description: title,
    deliveryId: delivery
  } = seller;
  const [showSellerDetail, setShowSellerDetail] = useState(showSellerDetailContent);

  const handleShowDetails = e => {
    onSellerClick(e, {
      id,
      delivery
    });
    setShowSellerDetail(!disableSellerDetails);
  };

  const handleCloseModal = () => {
    setShowSellerDetail(false);
    onCloseModalContent();
  };

  React.useEffect(() => {
    setShowSellerDetail(showSellerDetailContent);
  }, [showSellerDetailContent]);

  const handleLabelName = label => {
    if (internationalPartner && partnerLogo) {
      return /*#__PURE__*/React.createElement(PartnerLink, {
        title: `Logo ${delivery}`,
        "data-testid": `${delivery}logo`,
        children: /*#__PURE__*/React.createElement(GenericImageIcon, {
          href: partnerLogo,
          width: 77,
          height: 16
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    if (label === DEFAULT_SELLER) {
      return /*#__PURE__*/React.createElement(LogoMagaluIcon, {
        title: "Logo magalu",
        "data-testid": "magalogo",
        logoIconColor: logoIconColor
      });
    }

    if (magaluCompanies[label]) {
      const {
        id: partnerId,
        logo: Logo
      } = magaluCompanies[label];
      return /*#__PURE__*/React.createElement(PartnerLink, {
        title: `Logo ${partnerId}`,
        "data-testid": `${partnerId}logo`,
        children: /*#__PURE__*/React.createElement(Logo, {
          preserveAspectRatio: true
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    return /*#__PURE__*/React.createElement(Link, {
      onClick: disableSellerClick ? null : handleShowDetails,
      disableClick: disableSellerClick,
      children: title || delivery,
      "data-testid": "link"
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentBox, _extends({
    id: id,
    delivery: delivery,
    handleLabelName: handleLabelName,
    internationalPartner: internationalPartner,
    partnerColor: partnerColor
  }, props)), !disableSellerClick && !showDialog && /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    fullScreen: true,
    portal: true
  }, /*#__PURE__*/React.createElement(SidebarHeader, {
    label: modal.title || 'Informações da loja parceira',
    align: "left",
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: handleCloseModal
    }
  }), modal.content || /*#__PURE__*/React.createElement(SellerDetail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })), !disableSellerClick && !disableSellerDetails && showDialog && /*#__PURE__*/React.createElement(Dialog, {
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    position: "center",
    type: "responsive",
    showClose: true,
    title: modal.title,
    titleStyle: modal.titleStyle
  }, modal.content || /*#__PURE__*/React.createElement(SellerDetail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })));
};

process.env.NODE_ENV !== "production" ? SellerDelivery.propTypes = {
  product: shape({
    price: shape({
      currency: string
    })
  }),
  seller: shape({
    id: string,
    deliveryId: string,
    description: string
  }),
  onSellerClick: func,
  onCloseModalContent: func,
  onOffersClick: func,
  disableSellerClick: bool,
  showSellerDetailContent: bool,
  disableSellerDetails: bool,
  logoIconColor: string,
  showDialog: bool,
  modal: shape({
    title: string,
    content: node,
    titleStyle: shape({})
  }),
  internationalPartner: bool,
  partnerColor: string,
  partnerLogo: string
} : void 0;
SellerDelivery.defaultProps = {
  product: {},
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu'
  },
  onSellerClick: () => {},
  onOffersClick: () => {},
  disableSellerClick: false,
  onCloseModalContent: () => ({}),
  showSellerDetailContent: false,
  disableSellerDetails: false,
  logoIconColor: '',
  showDialog: false,
  modal: {
    title: ''
  },
  internationalPartner: false
};
export default SellerDelivery;